import React, { useMemo, useState } from 'react';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getRegionSelectedData } from '../NewFilter/util';

import './index.scss';

interface Props {
  className: string;
  value?: {
    category: string[];
    product: string[];
    category_type: 'category' | 'product';
  };
  popularList?: string[];
  activeTab?: 'common' | 'popular';
  locale?: 'en-US' | 'zh_CN';
  resultLable?: string[];
  globalDes?: string;
  regionCountry?: any[];
  globalMessageHidden?: boolean;
  language?: { [key: string]: string; };
  globalMsg?: string;
  onTabChange?: (activeTab?: 'common' | 'popular') => void;
  onChange?: (value: any) => void;
  onClose?: (value: any) => void;
}

const CateGorySelector = (props: Props) => {
  const {
    className,
    value: propsValue,
    regionCountry,
    locale,
    globalMsg = '',
    globalMessageHidden = false,
    activeTab = 'common',
    onTabChange,
    onChange,
    onClose,
    language,
  } = props;
  const [isHover, setIsHover] = useState(false);
  const hiddenList = ['all', '255'];

  const value = useMemo(() => ({
    markets: propsValue?.product,
    regions: propsValue?.category,
    region_type: propsValue?.category_type === 'category' ? 'region' : 'market',
  }), [propsValue]);

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: '全部',
      infoIcon: <span style={{ display: 'flex', alignItems: 'center' }}
        onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }}
      >
        <>
          {
            !globalMessageHidden ? (
              <Bubble
                style={{
                  // width: 350,
                  left: -18,
                }}
                placement='bottom-start'
                content={globalMsg}
                dark
              >
                {/* 此处必须包一层，不然点击不生效 */}
                <i><SvgIcon className='select-header-ic' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} /></i>
              </Bubble>
            ) : null
          }
        </>
      </span>
    }
  ];

  // 对数据格式进行处理，修改为新国家筛选器的格式
  const regionCountryOption = useMemo(() => regionCountry?.map((item) => {
    const itemObjChildren = item?.country?.map(items => 
    // 注意中英文和value的值（value有没有是英文名的特殊情况）
      ({
        ...items,
        text: items?.enText,
        // icon: getCountryFlag(items?.country_code),
        textCN: items?.chText,
        value: items?.country_code
      })
    );
    return {
      ...item,
      country: itemObjChildren,
      children: itemObjChildren,
      text: item?.region_name_en,
      textCN: item?.region_name_cn,
      value: item?.region_abbre,
    };
  })?.filter(item => !hiddenList.includes(item?.region_abbre?.toLowerCase())), [regionCountry]);

  const resultValue = useMemo(() => getRegionSelectedData(regionCountryOption, value), [value, regionCountry]);

  const handleNewConfirm = (value: any) => {
    onClose?.(value);
  };
  
  return (
    <>
      <NewRegionSelect
        language={language}
        value={resultValue}
        className={className}
        selectFilterType={'category'}
        dropdownClassName='region-selector-dropdown'
        boxClassName='dbd-category-selector-box'
        radioOptions={radioOptions}
        options={regionCountryOption}
        onCloseReginSelect={handleNewConfirm}
        onChange={(value) => {
          onChange?.(value);
          handleNewConfirm(value);
        }}
        closeOnScroll={true}
        popularList={[]}
        locale={locale}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
    </>
  );
};

export default CateGorySelector;
